import { render, staticRenderFns } from "./InventoryMovementsList.vue?vue&type=template&id=59fd8e66&scoped=true"
import script from "./InventoryMovementsList.vue?vue&type=script&lang=js"
export * from "./InventoryMovementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fd8e66",
  null
  
)

export default component.exports